import { useEffect } from "react";

/**
 * A hook to handle any uncatched promise rejections using onunhandledrejection event.
 */
export const useUnhandledRejectionListener = () => {
  useEffect(function listenUnhandledRejections() {
    const handleUnhandledRejection = (event) => {
      console.warn("UNHANDLED PROMISE REJECTION:", event.reason);
      event.preventDefault();
    };

    window.onunhandledrejection = handleUnhandledRejection;

    return () => {
      window.onunhandledrejection = null;
    };
  }, []);
};
